<template lang="pug">
  div
    modal(:name="modalName" :adaptive="true" width="600px"  height="auto" :clickToClose="false").autosplit-dialog-modal
      .modal-container
        template(v-if="splitAmount")
          i18n(tag="h3" path="line1")
            template(v-slot:amount)
              span.no-wrap {{ splitAmount.amount |moneyFormat(splitAmount.currency) }}
            template(v-slot:currency)
              span.no-wrap {{ splitAmount.currency | frontofficeCurrencyFilter }}
          i18n(tag="h3" path="line2")
            template(v-slot:amount)
              span.no-wrap {{ splitAmount.amount |moneyFormat(splitAmount.currency) }}
            template(v-slot:currency)
              span.no-wrap {{ splitAmount.currency | frontofficeCurrencyFilter }}

        br
        .modal-container__buttons
          button.btn.btn-danger(@click.prevent="onClickCancel") {{$t('btn_cancel')}}
          button.btn.btn-success-outline(@click.prevent="onClickSolid") {{$t('btn_send_solid')}}
          button.btn.btn-success(@click.prevent="onClickPartial") {{$t('btn_send_partial')}}
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import VModal from 'vue-js-modal';
import { MoneyAmount } from '@/models/finance/money';
import { MoneyFormatFilter } from '@/models/filters/money';
import { frontofficeCurrencyFilter } from '@/models/core/currency';

Vue.use(VModal);

@Component({
  name: 'autosplit-dialog-modal',
  filters: {
    moneyFormat: MoneyFormatFilter,
    frontofficeCurrencyFilter,
  },
})
export default class AutosplitDialogModal extends Vue {
  modalId = new Date().getTime() + Math.random()

  promiseCallbacks: any = { resolve: null, reject: null };

  splitAmount: MoneyAmount | null = null;

  get modalName() {
    return `modal-autosplit-payout-dialog-${this.modalId}`;
  }

  ask(amountToSplit: MoneyAmount | null) {
    // console.log('ask', amountToSplit);
    this.splitAmount = amountToSplit;

    if (!this.splitAmount || (this.splitAmount.amount == 0)) return Promise.resolve('submit-solid');

    this.showModal();
    return new Promise((resolve, reject) => {
      this.promiseCallbacks.resolve = resolve;
      this.promiseCallbacks.reject = reject;
    });
  }

  showModal() {
    this.$modal.show(this.modalName);
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  onClickCancel() {
    this.hideAndReject('cancel');
    this.hideModal();
  }

  onClickSolid() {
    this.hideAndResolve('submit-solid');
  }

  onClickPartial() {
    this.hideAndResolve('submit-partial');
  }

  hideAndResolve(data) {
    if (this.promiseCallbacks.resolve) this.promiseCallbacks.resolve(data);
    this.hideModal();
  }

  hideAndReject(data) {
    if (this.promiseCallbacks.reject) this.promiseCallbacks.reject(data);
    this.hideModal();
  }
}
</script>

<style scoped lang="less">
.autosplit-dialog-modal {
  .modal-container {
    padding: 20px 40px;
    h3 {
      line-height: 1.4em;
    }
    .no-wrap {
      white-space: nowrap;
      word-break: keep-all;
      font-weight: bolder;
    }
  }

  .modal-container__buttons {
    display: grid;
    grid-gap: 20px;
    align-items: center;
    justify-items: stretch;
    grid-template-columns: auto;
    grid-auto-flow: column;
  }
}

</style>

<i18n>
{
  "en": {
    "btn_send_partial": "Send in parts",
    "btn_send_solid": "Send in whole",
    "btn_cancel": "Cancel",
    "line1": "There is a provider's limit per single payment: {amount} {currency}.",
    "line2": "Do you want to split payment into parts by {amount} {currency}?"
  },
  "ru": {
    "btn_send_partial": "Отправить частями",
    "btn_send_solid": "Отправить целиком",
    "btn_cancel": "Отмена",
    "line1": "На стороне провайдера действует ограничение на максимальную сумму транзакции: не более {amount} {currency} в одном платеже.",
    "line2": "Хотите разбить платеж на части по {amount} {currency}?"
  }
}
</i18n>
